module.exports = __webpack_public_path__ + "media/images/globe-fda41cf126bb98fe4a45e83dd6ab30d3.png";